import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Polyfill adoptedStyleSheets access for browsers where it is missing or not array-like.
// Build stamp to force a new hashed bundle on rebuilds.
console.log('Dashboard build stamp:', new Date().toISOString());

try {
  const doc = document as any;
  const hasProp = Object.prototype.hasOwnProperty.call(doc, 'adoptedStyleSheets') ||
    'adoptedStyleSheets' in doc;

  if (!hasProp) {
    Object.defineProperty(doc, 'adoptedStyleSheets', {
      value: [],
      writable: true,
      configurable: true,
    });
  } else {
    const sheets = doc.adoptedStyleSheets;
    if (!Array.isArray(sheets) || typeof sheets.filter !== 'function') {
      const normalized = Array.isArray(sheets) ? sheets.slice() : Array.from(sheets || []);
      Object.defineProperty(doc, 'adoptedStyleSheets', {
        value: normalized,
        writable: true,
        configurable: true,
      });
    }
  }
} catch {
  // Ignore if property is read-only or unavailable.
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// change for the sake of vite rebuilding
